import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { LinkSubcontractorTableContext } from './LinkSubcontractorTable.context'
import { LinkedSubcontractor } from 'src/interfaces/subcontractor'

interface Props {
  contractor: LinkedSubcontractor
}

const LinkSubcontractorActionButtonComponent = ({ contractor }: Props) => {
  const { openLinkSubcontractorItemToAction } = useContext(LinkSubcontractorTableContext)

  const handleClickAction = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openLinkSubcontractorItemToAction(event, contractor)
    },
    [contractor],
  )

  return (
    <Button
      color="white"
      size="tiny"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClickAction}
    />
  )
}

export const LinkSubcontractorActionButton = memo(LinkSubcontractorActionButtonComponent)
